// config
import prependOptions from "../../../constants/EmployeePickerPrepend";

export default {
	pageName: "LaunchWorkflow",
	pageWrapperSpacing: 20,
	todosMaxCount: 50,
	workflowNameMaxCharacters: 250,
	todoNameMaxCharacters: 250,
	todoPrependOptions: prependOptions.filter((item) => ["self", "manager", "other"].indexOf(item.get("id")) >= 0),
	signaturePrependOptions: prependOptions.filter((item) => ["self", "manager"].indexOf(item.get("id")) >= 0),

	inputs: [
		{
			key: "workflowTemplate",
			_type: "picker",
			label: "Choose a workflow template",
			type: "workflowTemplates",
			defaultValue: "",
			isRequired: true,
		},
		{
			key: "workflowName",
			_type: "text",
			label: "Workflow name",
			defaultValue: "",
			isRequired: true,
		},
		{
			key: "startDate",
			_type: "datepicker",
			label: "Workflow Start date",
			defaultValue: "",
			props: { width: "auto" },
			isRequired: true,
		},
	],
};
